import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";

import '../css/topperSlide.css';

import defaultImage from '../images/empty_box.png';  // Ensure the path is correct
import { getClassListSvc, getSectionListSvc, getPtmTopperListSvc, getExamListSvc } from '../slidesSvc';
import Header from 'common/js/header/header';
import ClsHeader from "./clsHeader";
import TopperSlideComponent from "./topperSlideComponent";


function ToppersSlide() {
  // Separate states for each image

  const [loader, setLoader] = useState("none");
  const [opacity, setOpacity] = useState(1);

  const imgPath = "https://www.sms.cooledsys.com:8280/sms/student/docs/view?imgPath=";
  const [basePathPtmToppers, setBasePathPtmTopper] = useState("");

  const [lstExam, setLstExam] = useState([]);
  const [lstCls, setLstCls] = useState([]);
  const [lstSection, setLstSection] = useState([]);
  const [lstPtmTopper, setLstPtmTopper] = useState([]);

  const [ptmId, setPtmId] = useState(0);
  const [examId, setExamId] = useState(0);
  const [exam, setExam] = useState("");
  const [clsId, setClsId] = useState(0);
  const [cls, setCls] = useState("");
  const [section, setSection] = useState("");
  const [sectionId, setSectionId] = useState(0);
  const [key, setKey] = useState(0);

  const params = new URLSearchParams(window.location.search);



  useEffect(() => {
    // console.log("TopperSlider called");
    setClass();
    getExamList();
    setPtmId(params.get("ptmId") || 0);
  }, []);

  useEffect(() => {
    // console.log("TopperSlider called");
    if (ptmId && sectionId)
      getPtmTopperList(ptmId, sectionId);
  }, [ptmId, key, examId, sectionId]);


  const getExamList = () => {
    // console.log("getExamList called ");
    setLoader("block");
    setOpacity(0.5);
    getExamListSvc(examListResponse);
  }
  const examListResponse = (data) => {
    // console.log("examListResponse called, data", data);
    if (data.status === "Success") {
      setLstExam(data.lstExam);
      if (!examId && data.lstExam && data.lstExam.length > 0) {
        handleExamChange(data.lstExam[0].examId);
      }
    } else if (data.status === "Failure") {
      handleServiceError(data.message);
    } else {
      toast.error("Service failed in ExamListResponse " + data.message);
    }
    setLoader("none");
    setOpacity(1);
  }



  const getPtmTopperList = (pPtmId, pSectionId) => {
    // console.log("getPtmTopperList, pPtmId", pPtmId, ", pSectionId", pSectionId);
    getPtmTopperListSvc(pPtmId, pSectionId, getPtmTopperListResponse);
  }

  const getPtmTopperListResponse = (data) => {
    // console.log("getPtmTopperListResponse called, data", data);
    if (data.status === "Success") {
      setLstPtmTopper(data.lstPtmTopper);
      setBasePathPtmTopper(data.basePathPtmToppers);
    } else if (data.status === "Failure") {
      handleServiceError(data.message);
    } else {
      toast.error("Service failed " + data.error);
    }
  };

  const handleServiceError = (svcMsg) => {
    if (svcMsg === "You are not Logged In") {
      toast.error("You are not logged in. Redirecting to login page...");
      setTimeout(() => {
        window.location.href = "/";
      }, 2000);
    } else if (svcMsg === "Server Timed Out, Login Again") {
      toast.error("Server timed out. Redirecting to login page...");
      setTimeout(() => {
        window.location.href = "/";
      }, 2000);
    } else {
      toast.error(svcMsg);
    }
  };

  function setClass() {
    // console.log("setClassMethod called");
    getClassListSvc(cbClassResponse);
  }
  async function cbClassResponse(data) {
    // console.log("cbClassResponse called, data", data);
    var obj = data;
    if (obj.SvcStatus == 'Success') {
      await setLstCls(obj.lstCls);
      // console.log("obj.lstCls", obj.lstCls);
      var tmpClassId = obj.lstCls[0].classId;
      changeClass(tmpClassId);
    } else if (obj.SvcStatus == 'Failure') {
      if (obj.SvcMsg === 'You are not logged in') {
        setTimeout(function () { window.location.href = ('/') }, 2000);
        return false;
      }
      else if (obj.SvcMsg === 'Your Session is expired, login again') {
        setTimeout(function () { window.location.href = ('/') }, 2000);
        return false;
      } else {
        toast.error(obj.SvcMsg);
      }
    } else {
      toast.error("Service failed " + obj.SvcMsg);
    }
  }


  async function changeClass(pClsId) {
    // console.log("changeClass called, pClsId", pClsId, lstCls);
    await setClsId(pClsId);
    await setLstSection([]);
    const className = lstCls.find(cls => cls.classId === pClsId)?.classLabel || "Class";
    // console.log("className", className);
    await setCls(className);
    getSectionList(pClsId);
    // pClsId !== 0 && sectionId !== 0 && setSubjectScoreTable(sessionId, pClsId, sectionId);
  }

  function getSectionList(clsId) {
    // console.log("setSection called, clsId", clsId);
    getSectionListSvc(handleSectionResponse, clsId);
  }

  async function changeSection(pSectionId) {
    // console.log("changeSection called, pSectionId", pSectionId);
    setSectionId(pSectionId);
    const sectionName = lstSection.find(section => section.sectionId === pSectionId)?.section || "Section";
    // console.log("sectionName", sectionName);
    await setSection(sectionName);
  }

  async function cbClassResponse(data) {
    // console.log("cbClassResponse called, data", data);
    var obj = data;
    if (obj.SvcStatus == 'Success') {
      await setLstCls(obj.lstCls);
      // console.log("obj.lstCls", obj.lstCls);
      var tmpClassId = obj.lstCls[0].classId;
      changeClass(tmpClassId)
    } else if (obj.SvcStatus == 'Failure') {
      if (obj.SvcMsg === 'You are not logged in') {
        setTimeout(function () { window.location.href = ('/') }, 2000);
        return false;
      }
      else if (obj.SvcMsg === 'Your Session is expired, login again') {
        setTimeout(function () { window.location.href = ('/') }, 2000);
        return false;
      } else {
        toast.error(obj.SvcMsg);
      }
    } else {
      toast.error("Service failed " + obj.SvcMsg);
    }
  }


  function handleSectionResponse(data) {
    // console.log("handleSectionResponse called, data", data);
    return new Promise((resolve) => {
      var obj = data;
      if (obj.SvcStatus == 'Success') {
        setLstSection(obj.lstClassSection);
        // console.log("obj.lstClassSEction", obj.lstClassSection);
        if (obj.lstClassSection && obj.lstClassSection.length) {
          changeSection(obj.lstClassSection[0].sectionId, obj.lstClassSection[0].syllabusId)
        }
      } else if (obj.SvcStatus == 'Failure') {
        if (obj.SvcMsg === 'You are not logged in') {
          setTimeout(function () { window.location.href = ('/') }, 2000);
          return false;
        }
        else if (obj.SvcMsg === 'Your Session is expired, login again') {
          setTimeout(function () { window.location.href = ('/') }, 2000);
          return false;
        } else {
          toast.error(obj.SvcMsg);
        }
      } else {
        toast.error("Service failed " + obj.SvcMsg);
      }
      resolve();
    });
  }

  const handleExamChange = (pExamId) => {
    // console.log("handleExamChange called, pExamId", pExamId, lstExam);
    setExamId(pExamId);
    const selExam = lstExam.find(exam => exam.examId === pExamId)
    const examName = selExam ? selExam.exam : "";
    setExam(examName || "");
  }



  const updateKey = () => {
    // console.log("updateKey called");
    setKey(prevKey => prevKey + 1);
  }


  return (
    <div >
      <Header />
      <ToastContainer autoClose={3000} hideProgressBar />
      <div style={{ position: 'fixed', zIndex: 10000, width: 100, height: 100, marginLeft: -50, marginTop: -50, left: '50%', top: '50%', display: loader }}>
        <img className="loderImg" src={require("common/images/loader.gif")} alt="Loader..." />
      </div>
      <div className="col-md-12 col-xs-12 col-centered padding-remove "
        style={{
          cursor: (loader === "none") ? 'pointer' : 'none',
          pointerEvents: (loader === "none") ? 'auto' : 'none',
          opacity: opacity
        }}
      >
      </div>

      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 padding-remove toppers-slide">
        <div className="col-lg-11 col-md-11 col-sm-11 col-xs-12 col-centered  padding-remove">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 padding-remove" style={{ marginTop: "15px" }}>
            <div className="col-lg-2 col-md-3 col-sm-4 col-xs-4 padding-remove">
              <select
                className="form-control"
                value={examId}
                onChange={(e) => handleExamChange(e.target.value)}
              >
                <option value={0}>Exam</option>
                {lstExam.map((exam, index) => (
                  <option key={exam.examId} value={exam.examId}>{exam.exam}</option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 padding-remove" style={{ marginTop: "5px" }}>
            <div className="col-sm-5 padding-remove">
              <ClsHeader
                changeClass={changeClass}
                changeSection={changeSection}
                lstSection={lstSection}
                lstCls={lstCls}
                classId={clsId}
                selSectionId={sectionId}
              />
            </div>
          </div>

          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 padding-remove" >
            <TopperSlideComponent
              basePathPtmToppers={basePathPtmToppers}
              lstTopper={lstPtmTopper}
              examId={examId}
              clsId={clsId}
              sectionId={sectionId}
              ptmId={ptmId}
              exam={exam}
              cls={cls}
              updateKey={updateKey}
            />
          </div >
        </div >
      </div >
    </div >
  );
}

export default ToppersSlide;
